const transitionReset = (element1: string, element2: string, element3: string = "") => {
	let resizeTimer: ReturnType<typeof setTimeout>
	const target1 = document.querySelector(`${element1}`) as HTMLElement
	const target2 = document.querySelector(`${element2}`) as HTMLElement
	const target3 = document.querySelector(`${element3}`) as HTMLElement

	window.addEventListener('resize', () => {
		// Remove all transitions
		if (!target1 && !target2 && !target3) return
		if (target1) target1.style.transition = 'none'
		if (target2) target2.style.transition = 'none'
		if (target3) target3.style.transition = 'none'

		// clear timeout throughout resize
		clearTimeout(resizeTimer)

		resizeTimer = setTimeout(() => {
			if (!target1 && !target2 && !target3) return
			// Reapply transitions after resize ends by removing the inline override
			if (target1) target1.style.transition = ''
			if (target2) target2.style.transition = ''
			if (target3) target3.style.transition = ''
		}, 250)
	})
}

export default transitionReset
